export const DOCUMENT_TYPE_FAQ_CATEGORY = 'commerce.faqCategory';
export const DOCUMENT_TYPE_FAQ = 'commerce.faq';
export const FAQ_PAGE_ALL_SLUG = 'ofte-stilte-sporsmal';
export const DOCUMENT_TYPE_FAQ_ALL_PAGE = 'commerce.faqAllPage';
export const FAQ_ALL_PAGE_ID = 'commerceFaqAllPage';
